module.exports = __webpack_public_path__ + "images/vector/app/web/src/assets/briefcase icon-ae3385f6.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/briefcase icon.svg
// module id = ./app/web/src/assets/briefcase icon.svg
// module chunks = 0